(ns vit-configurator.views.intro
  (:require [re-frame.core :as re-frame]
            [vit-configurator.events :as events]
            [vit-configurator.subs :as subs]))

(defn customizer
  []
  (let [embedded-line1 @(re-frame/subscribe [::subs/embedded-line1])
        embedded-line1-hidden @(re-frame/subscribe [::subs/embedded-line1-hidden])
        embedded-line2 @(re-frame/subscribe [::subs/embedded-line2])
        embedded-line2-hidden @(re-frame/subscribe [::subs/embedded-line2-hidden])
        embedded-line3 @(re-frame/subscribe [::subs/embedded-line3])
        embedded-line3-hidden @(re-frame/subscribe [::subs/embedded-line3-hidden])]
    [:fieldset#intro
     [:legend "Provide intro text for the landing page"]
     [:p.mb-2.small "The text inputs provide the English translation only. Checking 'hide' hides the line in all languages."]
     [:label.pr-4 {:for "intro"} "Custom Landing Page Text"]
     [:div
      [:label.mb-2.small {:for "embedded-line1"} "Custom Text for Line 1"]
      [:div [:input#embedded-line1.mw-100
             {:type "text" :name "embedded-line1" :value (or embedded-line1 "")
              :maxLength "40"
              :on-change (fn [evt]
                           (let [val (.. evt -target -value)]
                             (re-frame/dispatch [::events/set-embedded-line1 val])))}]
       [:label.pl-2.pr-1 {:for "hide-embedded-line1"} "Hide "]
       [:input#hide-embedded-line1
        {:type "checkbox" :name "hide-embedded-line1"
         :checked embedded-line1-hidden
         :on-change (fn [evt]
                      (let [hidden? (.. evt -target -checked)]
                        (re-frame/dispatch [::events/set-embedded-line1-visibility hidden?])))}]]
      [:label.mb-2.small {:for "embedded-line2"} "Custom Text for Line 2"]
      [:div [:input#embedded-line2.mw-100
             {:type "text" :name "embedded-line2" :value (or embedded-line2 "")
              :maxLength "40"
              :on-change (fn [evt]
                           (let [val (.. evt -target -value)]
                             (re-frame/dispatch [::events/set-embedded-line2 val])))}]
       [:label.pl-2.pr-1 {:for "hide-embedded-line2"} "Hide"]
       [:input#hide-embedded-line2
        {:type "checkbox" :name "hide-embedded-line2"
         :checked embedded-line2-hidden
         :on-change (fn [evt]
                      (let [hidden? (.. evt -target -checked)]
                        (re-frame/dispatch [::events/set-embedded-line2-visibility hidden?])))}]]
      [:label.mb-2.small {:for "embedded-line3"} "Custom Text for Line 3"]
      [:div [:input#embedded-line3.mw-100.mb-0
             {:type "text" :name "embedded-line3" :value (or embedded-line3 "")
              :maxLength "40"
              :on-change (fn [evt]
                           (let [val (.. evt -target -value)]
                             (re-frame/dispatch [::events/set-embedded-line3 val])))}]
       [:label.pl-2.pr-1.mb-0 {:for "hide-embedded-line3"} "Hide"]
       [:input#hide-embedded-line3
        {:type "checkbox" :name "hide-embedded-line3"
         :checked embedded-line3-hidden
         :on-change (fn [evt]
                      (let [hidden? (.. evt -target -checked)]
                        (re-frame/dispatch [::events/set-embedded-line3-visibility hidden?])))}]]]]))
